import { createAssignment } from "@/api/assignments/createAssignment"
import { useMutation } from "@tanstack/react-query"

export const useCreateAssignment = () => {
  
  return useMutation({
    mutationKey: ["createAssignment"],
    mutationFn: createAssignment
  })
}